/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { getTelemetryObject, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';

import { Link } from './components/link';

import { IEcommPageNaviData } from './ecomm-page-navi.data';
import { IEcommPageNaviProps, ILinksData } from './ecomm-page-navi.props.autogenerated';

export interface IEcommPageNaviViewProps extends IEcommPageNaviProps<IEcommPageNaviData> {
    links?: React.ReactNode[];
    PageNaviContainer: any;
}

/**
 *
 * EcommPageNavi component
 * @extends {React.PureComponent<IEcommPageNaviProps<IEcommPageNaviData>>}
 */
class EcommPageNavi extends React.PureComponent<IEcommPageNaviProps<IEcommPageNaviData>> {
  private telemetryContent: ITelemetryContent = getTelemetryObject(this.props.context.request.telemetryPageName!,
    this.props.friendlyName, this.props.telemetry);

  public render(): JSX.Element | null {
    let navi = this._getCustomNaviLinks(0);

    const EcommPageNaviViewProps = {
      ...this.props,
      links: navi,
      PageNaviContainer: {
        className: 'ecomm-page-navi'
      }
    };

    return this.props.renderView(EcommPageNaviViewProps);
  }

  private _getCustomNaviLinks = (itemPosition: number): JSX.Element[] | null => {
    const { links } = this.props.config;

    if (!links || !(links.length > 0)) {
        this.props.context.telemetry.error('Navigation links content is empty, links will not render.');
        return null;
    }

    return (
      links.map((value: ILinksData, index: number) => {
        itemPosition++;

        const activeLink = window.location.href.includes(value.linkUrl.destinationUrl);

        let linkStyle = '';

        if (activeLink) {
          linkStyle = 'active-link';
        }

        return (
          <Link
            key={index}
            className={linkStyle}
            text={value.linkText}
            context={this.props.context}
            ariaLabel={value.ariaLabel || value.linkText}
            href={value.linkUrl && value.linkUrl.destinationUrl}
            index={{itemPosition}.toString()}
            telemetryContent={this.telemetryContent}
          />
        );
      })
    );
  }
}

export default EcommPageNavi;